import {Row, Col, Form} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {TFormSignature} from '../../signatureFormsTypes'
import {FormikErrors, FormikTouched} from 'formik'
import React from 'react'
import {RichTextEditor} from '../../../shared/RichTextEditor'
import {buildLocalizedPickers} from '../../signatureFormsConst'

interface SignatureFormContentProps {
  values: TFormSignature
  errors: FormikErrors<TFormSignature>
  touched: FormikTouched<TFormSignature>
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
}

export const SignatureFormContent: React.FC<SignatureFormContentProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  const intl = useIntl()
  const pickers = buildLocalizedPickers(intl)

  return (
    <div className='form-content'>
      <Row>
        <Col sm={12}>
          <div className='kt-heading kt-heading--md custom-border-brand'>
            <FormattedMessage
              id='documents.signatureForms.content.heading'
              defaultMessage='Signature form content'
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={12} className='form-content-text'>
          <Form.Group>
            <Form.Label>
              <FormattedMessage
                id='documents.signatureForms.field.emailContent'
                defaultMessage='Email content'
              /> {errors.formContent ? <small className='text-danger'>{errors.formContent}</small> : null}
            </Form.Label>
            <RichTextEditor
              value={values.formContent}
              placeholder={intl.formatMessage({
                id: 'documents.signatureForms.content.placeholder',
                defaultMessage: 'Enter signature form content',
              })}
              onChange={(e) => handleChange('formContent', e)}
              btnCustomPicker={pickers}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  )
}
